$(document).ready(function(){
  $('.Ugc_video_play').click(function(){
      $(this).hide();
      $(this).parent('div').find('.Ugc_video_pause').show();
      console.log('Play');
      var video = $(this).closest('.Ugc_section_outer').find('video')[0];
      if (video) {
          video.muted = false;
          video.play();
      }
  });

  $('.Ugc_video_pause').click(function(){
      $(this).hide();
      $(this).parent('div').find('.Ugc_video_play').show();
      console.log('Pause');
      var video = $(this).closest('.Ugc_section_outer').find('video')[0];
      if (video) {
          video.pause();
          video.currentTime = 0;
      }
  });

  $('.pp_shipping_info_out').mouseover(function(){
    $(this).addClass('visible');
  });

  $('.pp_shipping_info_out').mouseleave(function(){
    $(this).removeClass('visible');
  });


  $(document).scroll(function() {
        if ( $(document).scrollTop() >= 1300 ) {
            $('.main_product__sticky').addClass('visible');
        }
        else {
           $('.main_product__sticky').removeClass('visible');
        }
    });
});

class AtcStickyButton extends HTMLElement {
  constructor() {
    super();

    this.hasProductInCart = false;
    this.handleClick = this.handleClick.bind(this);
    this.handleCartLoaded = this.handleCartLoaded.bind(this);
    this.handleTargetingChanged = this.handleTargetingChanged.bind(this);
  }

  connectedCallback() {
    $(this).on("click", this.handleClick);
    document.addEventListener("cart-loaded", this.handleCartLoaded);
    document.addEventListener("targeting-changed", this.handleTargetingChanged);
  }

  disconnectedCallback() {
    $(this).off("click", this.handleClick);
    document.removeEventListener("cart-loaded", this.handleCartLoaded);
    document.removeEventListener("targeting-changed", this.handleTargetingChanged);
  }

  handleClick(e) {
    e.preventDefault();

    if(!this.hasProductInCart) {
      $('.js-add-to-cart').trigger('click');
    }
    else {
      window.location.href = '/checkout';
    }
  }

  handleTargetingChanged(e) {
    if(e.key === "CART_CHANGE") {
      this.applyCart(e.value);
    }
  }

  handleCartLoaded(e) {
    this.applyCart(e.detail);
  }

  applyCart(cart) {
    const {
      items
    } = cart;

    if(!loomi_ctx || !loomi_ctx.variantId) {
      return;
    }

    const product = items.find((cartItem) => {
      return cartItem.id.toString() === loomi_ctx.variantId.toString();
    });

    const totalQuantity = items.reduce((total, item) => {
      return total + (item.quantity > 5 ? 1 : 0);
    }, 0);

    if(product && (totalQuantity !== 1 && totalQuantity <= 20)) {
      this.hasProductInCart = true;
      this.classList.add("main_product__atc_sticky--checkout");
    }
    else {
      this.hasProductInCart = false;
      this.classList.remove("main_product__atc_sticky--checkout");
    }
  }
}

customElements.define("atc-sticky-button", AtcStickyButton);

// Once the page is scrolled: hide the sticky category row and switch the
// sticky nav to white text. Styles are applied inline because a third-party
// script on this store interferes with class-based stylesheet rules.
(function () {
  var apply = function (scrolled) {
    document.documentElement.classList.toggle("is-scrolled", scrolled);
    var cats = document.querySelector('[id*="__homepage_categories"]');
    if (cats) {
      cats.style.transition = "opacity 0.2s ease, visibility 0.2s ease";
      cats.style.opacity = scrolled ? "0" : "";
      cats.style.visibility = scrolled ? "hidden" : "";
      cats.style.pointerEvents = scrolled ? "none" : "";
    }
    var header = document.querySelector(".page-header .wt-header");
    if (header) {
      header.style.background = scrolled ? "#ffffff" : "";
    }
  };
  var onScroll = function () {
    apply(window.scrollY > 10);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();

// Review pop-up: clicking the Appio stars on a product card opens that product's reviews,
// 10 per page, with photos. Data comes from the same Appio endpoint the product page's own
// review widget uses. Card attributes (data-product-id/-handle/-title) are set in card.liquid.
(() => {
  const ENDPOINT = "/apps/appio/review/get-product-reviews-store";
  const PAGE_SIZE = 10;
  const BADGE = ".card__container--product > .appio-rating-badge";
  let modal, state;

  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const stars = (n) => {
    const r = Math.round(Number(n) || 0);
    return `<span class="rv-stars" aria-label="${r} von 5 Sternen">${"★".repeat(r)}<span class="rv-stars__off">${"★".repeat(5 - r)}</span></span>`;
  };
  const date = (iso) => { const d = new Date(iso); return isNaN(d) ? "" : d.toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric" }); };

  function build() {
    modal = document.createElement("div");
    modal.className = "rv-modal";
    modal.hidden = true;
    modal.innerHTML = `
      <div class="rv-modal__panel" role="dialog" aria-modal="true" aria-labelledby="rv-title">
        <div class="rv-modal__head">
          <div><h2 class="rv-modal__title" id="rv-title"></h2><div class="rv-modal__summary"></div></div>
          <button type="button" class="rv-modal__close" aria-label="Schließen">×</button>
        </div>
        <div class="rv-modal__body"></div>
        <nav class="rv-modal__foot" aria-label="Seiten" hidden></nav>
      </div>`;
    document.body.appendChild(modal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal || e.target.closest(".rv-modal__close")) return close();
      const p = e.target.closest("[data-rv-page]");
      if (p && !p.disabled) load(Number(p.dataset.rvPage));
    });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !modal.hidden) close(); });
  }

  function open(card, badge) {
    if (!modal) build();
    const raters = Number(badge.getAttribute("data-raters")) || 0;
    const rating = Number(badge.getAttribute("data-rating")) || 0;
    state = {
      id: card.dataset.productId,
      handle: card.dataset.productHandle,
      last: Math.max(1, Math.ceil(raters / PAGE_SIZE)),
      trigger: badge,
    };
    modal.querySelector(".rv-modal__title").textContent = card.dataset.productTitle || "";
    modal.querySelector(".rv-modal__summary").innerHTML =
      `${stars(rating)} <span>${rating ? rating.toFixed(1).replace(".", ",") : ""} · ${raters} Bewertungen</span>`;
    modal.hidden = false;
    document.documentElement.classList.add("rv-open");
    modal.querySelector(".rv-modal__close").focus();
    load(1);
  }

  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove("rv-open");
    state?.trigger?.focus();
  }

  async function load(page) {
    const body = modal.querySelector(".rv-modal__body");
    const req = (state.req = {});
    body.innerHTML = `<p class="rv-modal__status">Bewertungen werden geladen …</p>`;
    let reviews = [];
    try {
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", "query-cache-type": "none" },
        body: JSON.stringify({ page, sort: "date", groupId: "", productId: String(state.id), productName: "", productHandle: state.handle, featured: 0, pageSize: PAGE_SIZE, pinnedFirst: true }),
      });
      if (!res.ok) throw new Error(res.status);
      reviews = (await res.json()).reviews || [];
    } catch (err) {
      if (req !== state.req) return;
      body.innerHTML = `<p class="rv-modal__status">Die Bewertungen konnten gerade nicht geladen werden.</p>`;
      return;
    }
    if (req !== state.req) return; // a newer page request won
    // The star count on the card can include ratings without text; trust the data for the end.
    if (reviews.length < PAGE_SIZE) state.last = Math.max(1, reviews.length ? page : page - 1);
    if (!reviews.length && page > 1) return load(page - 1);
    body.innerHTML = reviews.length
      ? reviews.map((r) => {
          const imgs = String(r.images || "").split(",").map((u) => u.trim()).filter((u) => /^https:\/\//.test(u));
          return `<article class="rv-review">
            <div class="rv-review__top">${stars(r.rating)}<span class="rv-review__name">${esc(r.customer)}</span><span class="rv-review__date">${date(r.createdAt)}</span></div>
            ${r.title ? `<h3 class="rv-review__title">${esc(r.title)}</h3>` : ""}
            ${r.body ? `<p class="rv-review__text">${esc(r.body)}</p>` : ""}
            ${imgs.length ? `<div class="rv-review__media">${imgs.map((u) => `<a href="${esc(u)}" target="_blank" rel="noopener"><img src="${esc(u)}" alt="Kundenfoto" loading="lazy"></a>`).join("")}</div>` : ""}
          </article>`;
        }).join("")
      : `<p class="rv-modal__status">Noch keine Bewertungen mit Text.</p>`;
    body.scrollTop = 0;
    pager(page);
  }

  function pager(page) {
    const foot = modal.querySelector(".rv-modal__foot");
    const last = state.last;
    foot.hidden = last <= 1;
    if (last <= 1) return (foot.innerHTML = "");
    const nums = [...new Set([1, page - 1, page, page + 1, last])].filter((n) => n >= 1 && n <= last).sort((a, b) => a - b);
    let html = `<button type="button" class="rv-page" data-rv-page="${page - 1}" ${page <= 1 ? "disabled" : ""}>Zurück</button>`;
    nums.forEach((n, i) => {
      if (i && n - nums[i - 1] > 1) html += `<span class="rv-page rv-page--gap" aria-hidden="true">…</span>`;
      html += `<button type="button" class="rv-page" data-rv-page="${n}" ${n === page ? 'aria-current="page"' : ""}>${n}</button>`;
    });
    html += `<button type="button" class="rv-page" data-rv-page="${page + 1}" ${page >= last ? "disabled" : ""}>Weiter</button>`;
    foot.innerHTML = html;
  }

  const trigger = (e) => {
    const badge = e.target.closest?.(BADGE);
    if (!badge) return false;
    const card = badge.closest(".card__container--product");
    if (!card?.dataset.productId) return false;
    e.preventDefault();
    e.stopPropagation();
    open(card, badge);
    return true;
  };
  document.addEventListener("click", trigger, true);
  document.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") trigger(e); });

  // Appio injects the badges after load; make each one keyboard-reachable as it appears.
  const mark = () => document.querySelectorAll(`${BADGE}:not([role])`).forEach((b) => {
    b.setAttribute("role", "button");
    b.setAttribute("tabindex", "0");
    b.setAttribute("aria-label", "Bewertungen ansehen");
  });
  // Only look again when a node that is (or contains) an Appio badge was added. The page
  // changes hundreds of times while apps load; re-scanning the whole document after each
  // one cost ~270 full scans per page load.
  const hasBadge = (n) => n.nodeType === 1 && (n.classList.contains("appio-rating-badge") || n.getElementsByClassName("appio-rating-badge").length > 0);
  let queued = 0;
  new MutationObserver((records) => {
    if (queued) return;
    for (const r of records) {
      for (const n of r.addedNodes) {
        if (hasBadge(n)) { queued = requestAnimationFrame(() => { queued = 0; mark(); }); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  mark();
})();

/* Kaching Bundles "Kaufoptionen" boxes: replace Kaching's €/kg or €/l line with
   "0,12 € / Kapsel" or "0,34 € / Portion". Numbers come from the JSON that
   snippets/kaching-unit-price.liquid puts on product pages (see the note there).
     Kapsel:  box price / (quantity × capsules)
     Portion: box price × daily dose / (quantity × pack size)  — one portion = one day's dose
   Floored, like snippets/price-per-portion.liquid (green badge, search dropdown, cart page), so they never disagree. */
(() => {
  // "1.234,56 €" / "€1,234.56" -> { value, format(n) } keeping the shop's own currency layout.
  const parseMoney = (text) => {
    const m = text.match(/\d[\d.,\s]*/);
    if (!m) return null;
    const raw = m[0].trim();
    const comma = /,\d{2}$/.test(raw);
    const value = parseFloat(raw.replace(comma ? /[.\s]/g : /[,\s]/g, '').replace(',', '.'));
    if (!(value > 0)) return null;
    return {
      value,
      format: (n) => {
        const s = (Math.floor(n * 100) / 100).toFixed(2);
        return text.replace(raw, comma ? s.replace('.', ',') : s);
      },
    };
  };

  const update = (block, info) => {
    const data = info.variants[block.getAttribute('current-variant-id')];
    let config;
    try { config = JSON.parse(block.getAttribute('deal-block') || '{}'); } catch (e) { return; }
    const quantities = {};
    (config.dealBars || []).forEach((bar) => { quantities[bar.id] = bar.quantity; });

    block.querySelectorAll('.kaching-bundles__bar').forEach((bar) => {
      const row = bar.querySelector('.kaching-bundles__bar-pricing-row--secondary');
      const price = bar.querySelector('.kaching-bundles__bar-price');
      let ours = row && row.querySelector('.raibu-unit-price');
      const qty = quantities[bar.getAttribute('data-deal-bar-id')];
      const money = price && parseMoney(price.textContent.trim());

      if (!row || !data || !qty || !money) {
        if (ours) ours.remove();
        if (row) row.classList.remove('raibu-unit-swap');
        return;
      }
      const text = `${money.format((money.value * data[1]) / (qty * data[0]))} / ${info.label}`;
      if (!ours) {
        ours = document.createElement('div');
        ours.className = 'kaching-bundles__bar-unit-price raibu-unit-price';
        row.appendChild(ours);
      }
      if (ours.textContent !== text) ours.textContent = text;
      row.classList.add('raibu-unit-swap');
    });
  };

  // The data block is printed by snippets/kaching-unit-price.liquid on product pages only;
  // everywhere else there is nothing to do, so don't watch the page at all.
  const el = document.getElementById('raibu-unit-price-data');
  if (!el) return;
  let info;
  try { info = JSON.parse(el.textContent); } catch (e) { return; }

  const run = () => {
    document.querySelectorAll('kaching-bundles-block').forEach((block) => update(block, info));
  };

  // Re-run only for changes inside a Kaufoptionen block (prices, variant switch) or when a
  // block is added. Reacting to every change on the page re-ran this ~170 times per load.
  const KACHING = 'kaching-bundles-block';
  const touchesKaching = (r) => {
    const t = r.target.nodeType === 1 ? r.target : r.target.parentElement;
    if (t && (t.localName === KACHING || t.closest(KACHING))) return true;
    for (const n of r.addedNodes) {
      if (n.nodeType === 1 && (n.localName === KACHING || n.getElementsByTagName(KACHING).length > 0)) return true;
    }
    return false;
  };

  let queued = 0;
  new MutationObserver((records) => {
    if (!queued && records.some(touchesKaching)) queued = setTimeout(() => { queued = 0; run(); }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['current-variant-id'] });
  run();
})();
